<div nz-col nzSpan="24" nzOffset="1">
    

    <app-simple-table [listOfData]="listOfData" [listOfColumn]="listOfColumn" [type]="'short-url'"
        (deleteTriggred)="deleteShortUrl($event)" [pagination]="true"></app-simple-table>

</div>